// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ns-3";
export var downloadButton = "_ns-4";
export var fileContainer = "_ns-9 _ns-7";
export var fileContainerBase = "_ns-7";
export var fileContainerFixedHeight = "_ns-8 _ns-7";
export var fileInfo = "_ns-5";
export var fileInfoWidthRestricted = "_ns-6";
export var fileType = "_ns-1";
export var fileTypeName = "_ns-2";
export var image = "_ns-0";
export var link = "_ns-b";
export var overflowEllipsis = "_ns-a";